import script from "./button-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./button-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./button-setting-ly.vue?vue&type=style&index=0&id=e3624b3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3624b3a"]])

export default __exports__